import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css'

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-5" id='footer'>
      <Container>
        <Row>
          <Col md={4}>
            <h4 className="mb-4 heading4">Shivek Group</h4>
            <p>
              A leading group offering diverse services across various industries such as Food, Logistics, Travel, Real Estate, and more.
            </p>
            <ul className="list-unstyled">
              <li><FaPhoneAlt /> +91 9424809020  +91 7869085006</li>
              <li><FaEnvelope /> shiveke@gmail.com</li>
            </ul>
          </Col>

          <Col md={3}>
            <h5 className="mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/food" className="text-white">Food</Link></li>
              <li><Link to="/logistic" className="text-white">Logistics</Link></li>
              <li><Link to="/traveling" className="text-white">Travel</Link></li>
              <li><Link to="/ecommerce" className="text-white">E-Commerce</Link></li>
              <li><Link to="/realestate" className="text-white">Real Estate</Link></li>
              <li><Link to="/associate" className="text-white">Associate</Link></li>
            </ul>
          </Col>

          <Col md={3}>
            <h5 className="mb-4">Follow Us</h5>
            <div className="social-icons">
              <a href="https://facebook.com/shivekgroup" className="text-white mr-3"><FaFacebook size={24} /></a>
              <a href="https://twitter.com/shivekgroup" className="text-white mr-3"><FaTwitter size={24} /></a>
              <a href="https://instagram.com/shivekgroup" className="text-white mr-3"><FaInstagram size={24} /></a>
              <a href="https://linkedin.com/shivekgroup" className="text-white"><FaLinkedin size={24} /></a>
            </div>
          </Col>
        </Row>
        <hr className="border-white" />
        <Row className="text-center">
          <Col>
            <p>&copy; {new Date().getFullYear()} Shivek Group. All rights reserved.</p>
            <p>
              <Link to="/privacy-policy" className="text-white">Privacy Policy</Link> | 
              <Link to="/terms-of-service" className="text-white"> Terms of Service</Link>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
